import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";

import { useAppDispatch } from "app/hooks";
import { APPOINTMENT_OPPORTUNITY_FIELD } from "constants/feature-flags";
import { setOpportunityFieldEnabled } from "features/scheduling-v3/state/scheduler-v3.slice";

/**
 * Hands the `appointmentOpportunityField` flag (SN-19653) to Scheduling V3, which may not
 * import LaunchDarkly. Mounted beside `BookingDeskFlagSync`, for the same reason: the V3 form
 * also opens from a patient's chart. Until the flag is read it is `undefined`, which is off.
 */
export function OpportunityFieldFlagSync() {
  const enabled = useFlags()[APPOINTMENT_OPPORTUNITY_FIELD] === true;
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setOpportunityFieldEnabled(enabled));
  }, [dispatch, enabled]);
  return null;
}
